/**
 * @generated SignedSource<<e0a0f438a29ca4134693c335e9556a9c>>
 * @relayHash 5bdf665b1bbb40f2dbfa57980ce931f6
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/567.0.0-2026-07-09T16:56:40.509Z/submitSellerApplicationLeadMutation

import { ConcreteRequest } from 'relay-runtime';
export type SubmitSellerApplicationLeadInput = {
  captchaAction?: string | null;
  captchaKey?: string | null;
  captchaRequestUuid?: string | null;
  captchaToken?: string | null;
  city?: string | null;
  clientMutationId?: string | null;
  company?: string | null;
  country?: string | null;
  email?: string | null;
  eori?: string | null;
  facebook?: string | null;
  firstName?: string | null;
  hasExperienceSellingOnline?: boolean | null;
  instagram?: string | null;
  isConsignorsLead?: boolean | null;
  lastName?: string | null;
  leadSourceDetail?: string | null;
  phone?: string | null;
  postalCode?: string | null;
  state?: string | null;
  street?: string | null;
  website?: string | null;
};
export type submitSellerApplicationLeadMutation$variables = {
  input: SubmitSellerApplicationLeadInput;
};
export type submitSellerApplicationLeadMutation$data = {
  readonly SubmitSellerApplicationLead: {
    readonly leadId: string | null;
    readonly pass: boolean | null;
  } | null;
};
export type submitSellerApplicationLeadMutation = {
  response: submitSellerApplicationLeadMutation$data;
  variables: submitSellerApplicationLeadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitSellerApplicationLeadPayload",
    "kind": "LinkedField",
    "name": "SubmitSellerApplicationLead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "leadId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pass",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "submitSellerApplicationLeadMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "submitSellerApplicationLeadMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "app-buyer-misc/567.0.0-2026-07-09T16:56:40.509Z/submitSellerApplicationLeadMutation",
    "metadata": {},
    "name": "submitSellerApplicationLeadMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a8ccd480de07b4e05367a1d98dc99ab9";

export default node;
